import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrame } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrame(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function encodeImageFileAsURL() {
  var ff = (document.getElementById("inputFileToLoad") as HTMLInputElement)
    .files;
  if (ff) {
    if (ff.length > 0) {
      var fileToLoad = ff[0];

      var fileReader = new FileReader();

      fileReader.onload = function (fileLoadedEvent) {
        var hdr = "data:image/tiff;base64,";
        var srcData = (fileLoadedEvent.target?.result as string).substr(
          hdr.length
        );
        LwAPI?.openImageFromBase64(srcData).then(function (e) {
          if (e.error !== null) alert(e.msg);
        });
      };
      fileReader.readAsDataURL(fileToLoad);
    }
  }
}

function ex_openimg() {
  // TIFF image stored as base64 encoded string
  var data =
    "SUkqAEwBAAAmoLYKkpuV///y3DIwRg/LdOpV5Uf///////Bf/wf//////y3DKOPxEf//////" +
    "/////////////////////////////////////////////////zsTA8NT5WxP////+d4zhGD/" +
    "weVeVH//////////yOv////////////BDjj/xEf////////////8pa/0/8MPwAQAQCao7E0T" +
    "OIkl8N/7f+3/t/7f+3/t///t///lW2////b///xf/v////3///v//8igL/+P//////1//+v/" +
    "///1/r//+l//+l/lW//0v///S/xS/0v9L/S/0v9L/CX+EF/1/j//////////////////////" +
    "///H4/////////////////////////////////////gAgAgmqX//////////////////////" +
    "/////+MAEAERAP4ABAABAAAAAAAAAAABAwABAAAALAEAAAEBAwABAAAALAEAAAIBAwABAAAA" +
    "AQAAAAMBAwABAAAABAAAAAYBAwABAAAAAAAAAA0BAgAiAAAARgIAABEBBAADAAAAOgIAABIB" +
    "AwABAAAAAQAAABUBAwABAAAAAQAAABYBAwABAAAAgAAAABcBBAADAAAALgIAABoBBQABAAAA" +
    "HgIAABsBBQABAAAAJgIAABwBAwABAAAAAQAAACgBAwABAAAAAgAAAFMBAwABAAAAAQAAAAAA" +
    "AAAsAQAAAQAAACwBAAABAAAAlQAAAJQAAAAbAAAACAAAAJ0AAAAxAQAAQzpcVXNlcnNcamhh" +
    "cnRlclxEZXNrdG9wXHRlc3QudGlmAA==";

  LwAPI?.openImageFromBase64(data).then(function (result) {
    if (result.error !== null) alert(result.msg);
  });
}

// Bind functions to buttons
document
  .getElementById("inputFileToLoad")
  ?.addEventListener("change", async () => {
    await apiReady;
    encodeImageFileAsURL();
  });
document.getElementById("load")?.addEventListener("click", async () => {
  await apiReady;
  ex_openimg();
});
